import { combineReducers } from 'redux'
import view from './view'
import users from './users'
import userGroups from './userGroups'
import usersNotInBoard from './usersNotInBoard'
import lists from './lists'
import cards from './cards'
import archivedCards from './archivedCards'
import settings from './settings'
import chat from './chat'
import dates from './dates'
import documentSources from './documentSources'
import activities from './activities'
import labels from './labels'
import cardStatuses from './cardStatuses'
import incomingMails from './incomingMails'
import views from './views'
import documentTemplateSources from './documentTemplateSources'
import blockers from './blockers'

export default combineReducers({
  view,
  users,
  userGroups,
  usersNotInBoard,
  lists,
  cards,
  archivedCards,
  settings,
  chat,
  dates,
  documentSources,
  activities,
  labels,
  cardStatuses,
  incomingMails,
  views,
  documentTemplateSources,
  blockers,
})
